import React, { useState } from "react";
import { Row, Col, Label, Input } from "reactstrap";
import ProductCostingLink from "../karkhana/costing/ProductCostingLink";

export type InternalPriceName = "sellPrice" | "costPrice";

type ProductInternalUseSectionProps = {
  sellPrice?: string;
  costPrice?: string;
  readOnly?: boolean;
  /** Prices start hidden behind "click to show"; the edit steps show them, like the product list does. */
  masked?: boolean;
  onChange?: (patch: { name: InternalPriceName; value: string }) => void;
  /** Shows the Karkhana costing these prices come from (studio staff with Karkhana). */
  productUniqueId?: string;
  title?: string;
};

type RevealPriceFieldProps = {
  label: string;
  name: InternalPriceName;
  value?: string;
  readOnly?: boolean;
  masked?: boolean;
  onChange?: (patch: { name: InternalPriceName; value: string }) => void;
};

function RevealPriceField({
  label,
  name,
  value,
  readOnly,
  masked = true,
  onChange,
}: RevealPriceFieldProps) {
  const [shown, setShown] = useState(!masked);

  return (
    <Col xs={6}>
      <Label>{label}</Label>
      {shown ? (
        <Input
          type="number"
          name={name}
          id={name}
          className="form-control"
          placeholder={label}
          value={value ?? ""}
          readOnly={readOnly}
          onChange={(e) => {
            if (readOnly) {
              return;
            }
            onChange?.({ name, value: e.target.value });
          }}
        />
      ) : (
        <button
          type="button"
          className="form-control hkp-internal-price-mask"
          aria-label={`Show ${label}`}
          onClick={() => setShown(true)}
        >
          Hidden — click to show
        </button>
      )}
    </Col>
  );
}

export function ProductInternalUseSection({
  sellPrice,
  costPrice,
  readOnly,
  masked,
  onChange,
  productUniqueId,
  title = "Internal use only",
}: ProductInternalUseSectionProps) {
  return (
    <div className="formDiv hkp-internal-use">
      {title ? <p className="hkp-internal-use__title">{title}</p> : null}
      <Row>
        <RevealPriceField
          label="Selling Price"
          name="sellPrice"
          value={sellPrice}
          readOnly={readOnly}
          masked={masked}
          onChange={onChange}
        />
        <RevealPriceField
          label="Cost Price"
          name="costPrice"
          value={costPrice}
          readOnly={readOnly}
          masked={masked}
          onChange={onChange}
        />
      </Row>
      <ProductCostingLink productUniqueId={productUniqueId} />
    </div>
  );
}
